module.exports = __webpack_public_path__ + "static/media/time.d69d4b69.svg";